import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ThunderboltTwoTone,
} from "@ant-design/icons";
import { Button, Input, Space, Tooltip } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import { isValidEmail, snakeToCamel } from "utilities/generalUtility";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import labelStyles from "../candidateFieldLabel/candidateFieldLabel.module.scss";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export const CandidateEmailField = ({
  label,
  value,
  hireType,
  isEditable = false,
  disabled = false,
  onEdit,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [inputValue, setInputValue] = useState(value ?? "");
  const [validationError, setValidationError] = useState(null);
  const userSlice = useSelector(selectUser);

  const isSourceHired =
    hireType && snakeToCamel(hireType) === K.CandidateHireType.SourceHired;

  const suggestEmail = () => {
    const randomNumber = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    const email = `prospect.${Date.now()}.${randomNumber}.${userSlice.details?.id}@no-email.com`;
    setInputValue(email);
    setValidationError(null);
  };

  const handleSave = () => {
    const next = inputValue.trim() || null;
    if (!next) {
      setValidationError("Candidate email is required!");
      return;
    }
    if (!isValidEmail(next)) {
      setValidationError("Enter a valid email format!");
      return;
    }
    setValidationError(null);
    if (next !== value) onEdit?.(next);
    setIsEdit(false);
  };

  const handleCancel = () => {
    setInputValue(value ?? "");
    setValidationError(null);
    setIsEdit(false);
  };

  if (isEdit) {
    return (
      <div>
        <CandidateFieldLabel required>{label}</CandidateFieldLabel>
        <Input
          value={inputValue}
          style={{ width: "100%" }}
          status={validationError ? "error" : undefined}
          onChange={(e) => setInputValue(e.target.value)}
          addonAfter={
            isSourceHired ? (
              <Tooltip title="Autofill email for prospect candidate">
                <ThunderboltTwoTone
                  style={{ cursor: "pointer" }}
                  onClick={suggestEmail}
                />
              </Tooltip>
            ) : null
          }
        />
        {validationError && (
          <div className={labelStyles.errorMessage}>
            {validationError}
          </div>
        )}
        <div style={{ marginTop: 4 }}>
          <Button
            type="link"
            onClick={handleCancel}
            icon={<CloseCircleOutlined className="closeIcon" />}
          />
          <Button
            type="link"
            onClick={handleSave}
            icon={<CheckCircleOutlined className="checkIcon" />}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      <Space size={4} style={{ minHeight: 24 }}>
        <CandidateFieldValue>{value ?? K.NullPlaceholder}</CandidateFieldValue>
        {isEditable && !disabled && (
          <Button
            style={{ width: 16, height: 16 }}
            type="link"
            onClick={() => {
              setInputValue(value ?? "");
              setIsEdit(true);
            }}
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </div>
  );
};
